// utils/api/topup.js
import API from "./index.js";

export async function fetchTopupOffers(filters = {}) {
  const params = {
    _limit: filters.limit ?? 20,
    _offset: filters.offset ?? 0,
    ...(filters.country ? { country: String(filters.country).trim().toUpperCase() } : {}),
    ...(filters.brand ? { brand: String(filters.brand).trim() } : {}),
    ...(filters.subType ? { subType: String(filters.subType).trim() } : {}),
    ...(filters.region ? { region: String(filters.region).trim() } : {}),
  };

  try {
    const res = await API.get("/topups/offers", { params });
    return res.data; // { list, total, limit, offset, facets? }
  } catch (err) {
    console.error(
      "[TopupService] Failed to get top-up offers:",
      err.response?.data || err.message
    );
    throw err;
  }
}

export async function fetchTopupRegions(filters = {}) {
  const params = {
    ...(filters.country ? { country: String(filters.country).trim().toUpperCase() } : {}),
  };

  try {
    const res = await API.get("/topups/regions", { params });
    return res.data || [];
  } catch (err) {
    console.error("❌ Failed to fetch topup regions:", err.response?.data || err.message);
    return [];
  }
}

export async function fetchTopupCountries() {
  try {
    const res = await API.get("/topups/countries");
    return res.data; // e.g. [{ code: "GH" }, ...] or ["GH", ...]
  } catch (err) {
    console.error(
      "❌ Failed to fetch countries:",
      err.response?.data || err.message
    );
    throw err;
  }
}

export async function purchaseTopup(data) {
  const res = await API.post("/transactions/topup", data);
  return res.data;
}
